import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  closeInnerPopup,
  openInnerPopup,
} from '../../data/providers/popupsProvider';
import { IMetric, ITestType } from '../../data/types';
import { Button } from './Button';
import { CardBody } from './card/CardBody';
import { CardFooter, CardFooterLeft, CardFooterRight } from './card/CardFooter';
import { CardHeader, CardHeaderLeft } from './card/CardHeader';
import { IconButton } from './Button';
import { InnerPopupCard, PopupCardContent } from './popups/PopupCard';

interface IMetricData {
  testType: ITestType;
  metric: IMetric;
}

interface IExpandedMetricProps {
  onClose: () => void;
  metricData: IMetricData;
}

export const ExpandedMetric = (
  props: IExpandedMetricProps
): React.ReactElement => {
  return (
    <InnerPopupCard onClose={props.onClose} size='small'>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h4 style={{ paddingLeft: '10px' }}>
              {props.metricData.metric.label}
            </h4>
          </CardHeaderLeft>
        </CardHeader>
        <CardBody style={{ padding: '10px 20px' }}>
          <h6>Units: {props.metricData.metric.units}</h6>
          <h6>Description: {props.metricData.metric.description}</h6>
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft />
          <CardFooterRight>
            <Button onClick={props.onClose} title='Close' />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </InnerPopupCard>
  );
};

interface IProps extends RouteComponentProps {
  metricData: IMetricData;
}

export const OpenExpandedMetric = withRouter(
  (props: IProps): React.ReactElement => {
    const openDialog = (): void =>
      openInnerPopup(
        <ExpandedMetric
          metricData={props.metricData}
          onClose={closeInnerPopup(props.history)}
        />,
        props.history,
        'expanded-metric'
      );
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>{props.metricData.metric.label}</span>
        <IconButton icon='info' onClick={openDialog} title='More Info' />
      </div>
    );
  }
);
